import { z } from "zod";

export const sandboxArtifactSchema = z.object({
  artifactId: z.string().uuid(),
  filename: z.string().min(1).max(512),
  mimeType: z.string().min(1).max(255),
  sizeBytes: z.number().int().nonnegative(),
});
export type SandboxArtifact = z.infer<typeof sandboxArtifactSchema>;
export const sandboxArtifactDownloadSchema = z.object({
  url: z
    .string()
    .url()
    .refine((value) => new URL(value).protocol === "https:", {
      message: "The file link could not be opened.",
    }),
  expiresIn: z.number().positive(),
});

export function parseChatArtifacts(
  text: string | undefined,
): SandboxArtifact[] {
  if (!text) return [];
  try {
    const result = z
      .object({
        content: z.object({
          artifacts: z.array(sandboxArtifactSchema).max(20),
        }),
      })
      .safeParse(JSON.parse(text));
    return result.success ? result.data.content.artifacts : [];
  } catch {
    return [];
  }
}
